const headerSearch = (() =>{
    const initBlock = el => {
        handleSearch(el);
    };    
    const handleSearch = el => {
        const searchInput = el.querySelector('input[type="search"]');
        let resultsWrapper = el.querySelector('[data-header-search-results]');
        searchInput.addEventListener('keyup', () => {
            resultsWrapper = el.querySelector('[data-header-search-results]');
            if (searchInput.value.length >= 3){
                fetch(`/umbraco/surface/search/HeaderSearch?searchTerm=${searchInput.value}`)
                    .then(response => response.text())
                    .then(data => {
                        if (resultsWrapper && data){
                            resultsWrapper.classList.remove('hidden');
                            resultsWrapper.outerHTML = data;
                        }
                    })
                    .catch(_ => {});
            }else {
                resultsWrapper.innerHTML = '';
                resultsWrapper.classList.add('hidden');
            }
        });
    }
    return {initBlock};
})();
document.querySelectorAll('[data-header-search]').forEach(el => headerSearch.initBlock(el));